<script setup>
import { useAuthStore } from '@/stores/auth.js';
import { useBroadcastChannel } from '@vueuse/core';
const authStore = useAuthStore();

const logout = () => {
    authStore.logout(); // Llama a la acción de logout para cerrar sesión
}
</script>

<template>
    <li class="nav-item dropdown desk align-content-center">
        <a class="nav-link dropdown-toggle py-0 d-flex align-items-center" href="#" id="navbarDropdown" role="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            <!-- <img src="https://cdn.pixabay.com/photo/2020/07/01/12/58/icon-5359553_1280.png" alt="User-Profile"
                class="img-xs rounded-circle img-fluid"> -->
            <i class="fa-solid fa-user-shield"></i>
            <div class="caption ms-3 ">
                <h6 class="mb-0 caption-title">
                    {{ authStore.authUser }}
                </h6>
                <p class="mb-0 caption-sub-title"></p>
            </div>
        </a>
        <ul class="dropdown-menu dropdown-menu-end">
            <!-- <li>
                <hr class="dropdown-divider">
            </li> -->
            <a class="dropdown-item" href="/profile">
                <i class="fa-solid fa-user-gear text-warning fa-fw me-1"></i>Mi Perfil</a>
            <li>
                <hr class="dropdown-divider">
            </li>
            <li>
                <a class="dropdown-item" href="#" @click="logout">
                    <i class="fa-solid fa-right-from-bracket fa-fw text-danger me-1"></i>Salir</a>
            </li>
        </ul>
    </li>
    <li class="nav-item dropdown mobile align-content-center">
        <a class="nav-link dropdown-toggle d-flex align-items-center" href="#" id="navbarDropdown" role="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            <!-- <img src="https://cdn.pixabay.com/photo/2020/07/01/12/58/icon-5359553_1280.png" alt="User-Profile"
                class="img-xs rounded-circle img-fluid"> -->
            <i class="fa-solid fa-user-shield"></i>
        </a>
        <ul class="dropdown-menu dropdown-menu-end">
            <li class="text-center"> {{ authStore.authUser }}
                <p class="mb-0 caption-sub-title"></p>
            </li>
            <li>
                <hr class="dropdown-divider">
            </li>
            <a class="dropdown-item" href="/configuracion/usuario/perfil">
                <i class="fa-solid fa-user-gear text-warning px-2"></i>Mi Perfil</a>
            <li>
                <hr class="dropdown-divider">
            </li>
            <li>
                <a class="dropdown-item" href="#" @click="logout">
                    <i class="fa-solid fa-right-from-bracket text-danger  px-2 "></i>Salir</a>
            </li>
        </ul>
    </li>
</template>


<style>
.caption-sub-title {
    font-size: 7pt;
}

.caption-title {
    font-weight: bold;

}

.img-xs {
    width: 35px;
    height: 35px;
}

@media only screen and (max-width: 576px) {
    .desk {
        display: none;
    }
}

@media only screen and (min-width: 576px) {
    .mobile {
        display: none;
    }
}
</style>
